export default __webpack_public_path__ + "e1ce59fefe69468dadc27981b2c84776.png";